import { lazy } from 'react';

import { TRoute } from 'shared/presentation/modules/definitions';

const EmployeeHiringLink = lazy(
  () => import('modules/employee/presentation/pages/EmployeeHiringLink'),
);

const routes: TRoute[] = [
  {
    type: 'route',
    path: '/proposta-contratacao-colaborador/:hash',
    component: EmployeeHiringLink,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
];

export default routes;
